import { IEmailClientConfig } from '../models/personalization.model';

export interface IPersonalizationConfigurations {
  emailConfig: IEmailClientConfig
}

export const initialPersonalizationConfigurationsState: IPersonalizationConfigurations = {
  emailConfig: null
};
